import React from 'react';
import {
  Tabs,
  Tab,
  Box,
  Button,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  Card
} from '@mui/material';
import Client from '../Client';
import Config from '../ClientConfig';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { locationsList } from './simpleBiReportsApi';

class PurchaseOrderUI extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      tabIndex: 0,
      isSubmitting: false,
      purchaseOrders: [],
      productEntries: [],

      orderData: {
        type: '',
        promisedDate: '',
        location: 0,
        description: '',
        supplier: '',
        PurchaseOrderProductEntry_po: []
      },

      tabs: ['Orders List', 'New Order'],
      selectedOrder: null,
      showDetailDialog: false,
      internalSupplier: 1,
      location: 0,
      selectedLocationFilter: 0,
      locations: [{ iref: 0, name: "Select Location" }]
    };

    this.getData = this.getData.bind(this);
    this.selectLocation = this.selectLocation.bind(this);
    this.fetchPurchaseOrders = this.fetchPurchaseOrders.bind(this);
  }

  componentDidMount() {
    this.fetchPurchaseOrders();
    this.getData();
  }

  fetchPurchaseOrders = (locationId = null) => {
    const queryData = {
      type: 0,
    };

    if (locationId && Number(locationId) !== 0) {
      queryData.location = locationId;
    }

    let data = this.state.client.getData(Config.API_URL_PURCHASE_ORDERS, queryData);

    if (data) {
      let checks = [];

      if (Array.isArray(data)) {
        checks = data;
      } else if (Array.isArray(data.purchaseOrder)) {
        checks = data.purchaseOrder;
      } else if (data.purchaseOrder) {
        checks = [data.purchaseOrder];
      }

      this.setState({ purchaseOrders: checks });
    }
  };

  getData() {
    let psiData = this.state.client.getData(Config.API_URL_PRODUCT_SUPPLIER_INFO, { active: 1 });

    if (psiData) {
      this.setState({ psiData: psiData });
    }

    let queryData = {
      status: 2,
      isPurchased: 1,
      orderBy_name: 1,
    };

    let data = this.state.client.getData(Config.API_URL_PRODUCT, queryData);

    if (data && psiData) {
      const quantityMultiplierMap = {};
      const psiActiveMap = {};
      const centralSupplyMap = {};

      if (Array.isArray(psiData.productSupplierInfo)) {
        psiData.productSupplierInfo.forEach(info => {
          if (info.preferred) {
            quantityMultiplierMap[info.product.iref] = info.quantityMultiplier;
            psiActiveMap[info.product.iref] = info.active;
            centralSupplyMap[info.product.iref] = info.centralSupply;
          }
        });
      }

      const products = data.products || {};

      const productEntries = Object.keys(products).map((key) => {
        const fData = products[key];

        return {
          productId: fData.iref,
          productName: fData.name,
          unit: fData.unitType,
          inputQuantity: '',
          quantity: 0,
          reactKey: `${fData.iref}-${key}`,
          active: psiActiveMap[fData.iref],
          centralSupply: centralSupplyMap[fData.iref],
          quantityMultiplier: quantityMultiplierMap[fData.iref] ?? 1,
        };
      });

      let configData = { key: "INTERNAL_SUPPLIER_COMPANY_IREF" };
      let supplierConfig = this.state.client.getData(Config.API_URL_CONFIG_SALESAPP, configData);

      let internalSupplier = 1;

      if (supplierConfig) {
        internalSupplier = supplierConfig.SalesAppConfigs[0]?.value;
      }

      this.setState({
        products,
        productEntries,
        internalSupplier
      });
    } else {
      alert('Failed to load products.');
    }

    let locations = locationsList(this.state.client);

    if (locations && Array.isArray(locations.locations)) {
      this.setState({ locations: locations.locations });
    }
  }

  handleLocationFilterChange = (e) => {
    const locationId = e.target.value;

    this.setState({ selectedLocationFilter: locationId }, () => {
      this.fetchPurchaseOrders(locationId);
    });
  };

  selectLocation = (event) => {
    const value = event.target.value;

    this.setState(
      { location: value },
      function () {
        this.handleOrderChange('location', value);
      }
    );
  }

  handleChange = (event, newValue) => {
    this.setState({ tabIndex: newValue });
  };

  handleOrderChange = (field, value) => {
    this.setState(prev => ({
      orderData: {
        ...prev.orderData,
        [field]: value
      }
    }));
  }

  handleQuantityChange = (index, value) => {
    const productEntries = [...this.state.productEntries];
    const entry = productEntries[index];

    const inputQty = parseFloat(value) || 0;

    entry.inputQuantity = value;
    entry.quantity = inputQty * entry.quantityMultiplier;

    this.setState({ productEntries });
  }

  handleSubmit = () => {
    if (this.state.isSubmitting) return;

    const { orderData, productEntries, internalSupplier } = this.state;

    if (!orderData.promisedDate || !orderData.location || Number(orderData.location) === 0) {
      alert('Please fill in both Date and Location before submitting.');
      return;
    }

    const filteredProducts = productEntries
      .filter(p => p.quantity && !isNaN(p.quantity) && parseFloat(p.quantity) > 0)
      .map(p => ({
        product: p.productId,
        unit: p.unit,
        quantity: parseFloat(p.quantity)
      }));

    if (filteredProducts.length === 0) {
      alert("Please enter at least one product line with quantity > 0.");
      return;
    }

    this.setState({ isSubmitting: true });

    const now = new Date();
    const createdOn = now.toISOString();
    const documentDate = now.toISOString().split('T')[0];
    const type = 0;
    const supplier = internalSupplier;

    const payload = {
      ...orderData,
      type,
      supplier,
      createdOn,
      documentDate,
      PurchaseOrderProductEntry_po: filteredProducts
    };

    const result = this.state.client.pushData(Config.API_URL_PURCHASE_ORDERS, payload);

    if (result && result.iref) {
      alert("Order saved!");

      this.setState(prev => ({
        orderData: {
          type: 0,
          promisedDate: '',
          location: 0,
          supplier: 2,
          description: ''
        },
        productEntries: prev.productEntries.map(p => ({
          ...p,
          quantity: 0,
          inputQuantity: ''
        })),
        location: 0,
        tabIndex: 0,
        isSubmitting: false
      }));

      this.fetchPurchaseOrders();
    } else {
      console.error('Save failed', result);

      const errorMessage = result?.message || "Save failed.";

      this.setState({ isSubmitting: false });
      alert(errorMessage);
    }
  };

  openOrderDetail = (po) => {
    this.setState({
      selectedOrder: po,
      showDetailDialog: true
    });
  };

  closeOrderDetail = () => {
    this.setState({
      showDetailDialog: false,
      selectedOrder: null
    });
  };

  getLocations() {
    let locations = [{ iref: 0, name: "Select Location" }];

    if (this.state.locations) {
      Object.keys(this.state.locations).forEach(key => {
        let fData = this.state.locations[key];

        if (fData && fData.iref !== undefined) {
          let myData = { iref: fData.iref, name: fData.name };
          locations.push(myData);
        }
      });
    }

    return locations;
  }

  renderOrderList = () => {
    let locations = this.getLocations();

    return (
      <Box
        sx={{
          height: "100%",
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box
          sx={{
            px: {
              xs: 1,
              sm: 1.5
            },
            py: {
              xs: 0.75,
              sm: 1
            },
            borderBottom: "1px solid rgba(0,0,0,0.08)"
          }}
        >
          <TextField
            id="standard-select-location-filter"
            select
            required
            value={this.state.selectedLocationFilter}
            variant="standard"
            size="small"
            sx={{
              width: {
                xs: "100%",
                sm: 220
              },
              "& .MuiInputBase-input": {
                fontSize: {
                  xs: "16px",
                  sm: "14px"
                }
              },
              "& .MuiInputLabel-root": {
                fontSize: {
                  xs: "13px",
                  sm: "13px"
                }
              }
            }}
            onChange={this.handleLocationFilterChange}
          >
            {locations.map((option) => (
              <MenuItem key={option.iref} value={option.iref}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>
        </Box>

        <Box
          sx={{
            flex: 1,
            minHeight: 0
          }}
        >
          <TableContainer
            sx={{
              height: "100%",
              overflow: "auto"
            }}
          >
            <Table stickyHeader size="small" aria-label="purchase orders table">
              <TableHead>
                <TableRow>
                  <TableCell sx={this.headerCellSx("center")}>
                    <b>IREF</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("left", 105)}>
                    <b>Date</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("left", 125)}>
                    <b>Promised</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("left")}>
                    <b>Location</b>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {(this.state.purchaseOrders || []).map((po, idx) => (
                  <TableRow
                    key={idx}
                    hover
                    onClick={() => this.openOrderDetail(po)}
                    sx={{ cursor: 'pointer' }}
                  >
                    <TableCell sx={this.bodyCellSx("center", false)}>
                      {po.iref || po.id}
                    </TableCell>

                    <TableCell sx={this.bodyCellSx("left", false, 105)}>
                      {po.documentDate}
                    </TableCell>

                    <TableCell sx={this.bodyCellSx("left", false, 125)}>
                      {po.promisedDate}
                    </TableCell>

                    <TableCell sx={this.bodyCellSx("left")}>
                      {po.location?.name || po.location?.uid || '-'}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    );
  };

  renderNewOrderForm = () => {
    const { orderData } = this.state;

    const activeEntries = this.state.productEntries
      .map((e, i) => ({ ...e, __idx: i }))
      .filter(p => p.active === true && p.centralSupply === true);

    let locations = this.getLocations();

    const unitTypeMap = { 0: 'pc', 1: 'kg' };

    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const minDate = `${yyyy}-${mm}-${dd}`;

    const maxDateObj = new Date(today);
    maxDateObj.setDate(maxDateObj.getDate() + 30);

    const yyyyMax = maxDateObj.getFullYear();
    const mmMax = String(maxDateObj.getMonth() + 1).padStart(2, '0');
    const ddMax = String(maxDateObj.getDate()).padStart(2, '0');
    const maxDate = `${yyyyMax}-${mmMax}-${ddMax}`;

    return (
      <Box
        sx={{
          height: "100%",
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box
          sx={{
            px: {
              xs: 1,
              sm: 1.5
            },
            py: {
              xs: 0.75,
              sm: 1
            },
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr 1fr",
              sm: "170px 220px auto"
            },
            gap: {
              xs: 1,
              sm: 1.25
            },
            alignItems: "end",
            borderBottom: "1px solid rgba(0,0,0,0.08)"
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Promised"
              value={orderData.promisedDate ? dayjs(orderData.promisedDate) : null}
              onChange={(newValue) => {
                const formattedDate = newValue ? newValue.format('YYYY-MM-DD') : '';
                this.handleOrderChange('promisedDate', formattedDate);
              }}
              minDate={dayjs(minDate)}
              maxDate={dayjs(maxDate)}
              inputFormat="DD.MM.YYYY"
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  size="small"
                  sx={this.filterSx()}
                  InputLabelProps={{ shrink: true }}
                />
              )}
              required
            />
          </LocalizationProvider>

          <TextField
            id="standard-select-location"
            select
            required
            value={orderData.location}
            variant="standard"
            size="small"
            sx={this.filterSx()}
            onChange={this.selectLocation}
          >
            {locations.map((option) => (
              <MenuItem key={option.iref} value={option.iref}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>

          <Box sx={{ display: { xs: "none", sm: "block" } }} />
        </Box>

        <Box
          sx={{
            flex: 1,
            minHeight: 0
          }}
        >
          <TableContainer
            sx={{
              height: "100%",
              overflow: "auto"
            }}
          >
            <Table stickyHeader size="small" aria-label="new purchase order table">
              <TableHead>
                <TableRow>
                  <TableCell sx={this.headerCellSx("left", null, true)}>
                    <b>Product</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("right", 96, true)}>
                    <b>Input Qty</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("right", 96, true)}>
                    <b>Qty</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("center", 48, true)}>
                    <b>Unit</b>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {activeEntries.map((entry) => (
                  <TableRow key={entry.reactKey || entry.productId}>
                    <TableCell sx={this.bodyCellSx("left", false, null, true)}>
                      {entry.productName}
                    </TableCell>

                    <TableCell sx={this.bodyCellSx("right", false, 96, true)}>
                      <TextField
                        type="number"
                        size="small"
                        value={entry.inputQuantity}
                        onChange={e => {
                          const val = e.target.value;

                          if (/^\d*$/.test(val)) {
                            this.handleQuantityChange(entry.__idx, val);
                          }
                        }}
                        inputProps={{
                          step: '0.001',
                          inputMode: 'decimal',
                          min: 0,
                          style: { textAlign: 'right' }
                        }}
                        InputProps={{
                          sx: {
                            py: 0.2,
                            height: '34px',
                            width: {
                              xs: '78px',
                              sm: '90px'
                            },
                            fontSize: {
                              xs: '16px',
                              sm: '14px'
                            },
                            backgroundColor: entry.quantityMultiplier > 1 ? '#fff3cd' : 'inherit',
                          }
                        }}
                      />
                    </TableCell>

                    <TableCell sx={this.bodyCellSx("right", false, 96, true)}>
                      <TextField
                        size="small"
                        value={Number(entry.quantity || 0).toLocaleString()}
                        inputProps={{
                          step: '0.001',
                          inputMode: 'decimal',
                          min: 0,
                          style: { textAlign: 'right' }
                        }}
                        InputProps={{
                          readOnly: true,
                          sx: {
                            py: 0.2,
                            height: '34px',
                            width: {
                              xs: '78px',
                              sm: '90px'
                            },
                            fontSize: {
                              xs: '16px',
                              sm: '14px'
                            }
                          }
                        }}
                      />
                    </TableCell>

                    <TableCell sx={this.bodyCellSx("center", false, 48, true)}>
                      {unitTypeMap[entry.unit]}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <Box
          sx={{
            px: {
              xs: 1,
              sm: 1.5
            },
            py: {
              xs: 1,
              sm: 1.25
            },
            borderTop: "1px solid rgba(0,0,0,0.08)",
            display: "flex",
            justifyContent: "center"
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{
              minWidth: {
                xs: "100%",
                sm: 220
              },
              px: 3
            }}
            onClick={this.handleSubmit}
            disabled={this.state.isSubmitting}
          >
            Save Order
          </Button>
        </Box>
      </Box>
    );
  };

  renderOrderDetailDialog = () => {
    const { selectedOrder } = this.state;

    if (!selectedOrder) return null;

    const unitTypeMap = { 0: 'pc', 1: 'kg' };

    return (
      <Dialog
        open={this.state.showDetailDialog}
        onClose={this.closeOrderDetail}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            m: 0,
            p: {
              xs: 1.5,
              sm: 2
            },
            pr: 7,
            fontSize: {
              xs: "15px",
              sm: "18px"
            },
            fontWeight: 700
          }}
        >
          Order Detail - {selectedOrder.iref || selectedOrder.id}

          <IconButton
            aria-label="close"
            onClick={this.closeOrderDetail}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            px: {
              xs: 1.5,
              sm: 2
            }
          }}
        >
          <Typography sx={this.dialogInfoSx()}>
            Document Date: {selectedOrder.documentDate}
          </Typography>

          <Typography sx={this.dialogInfoSx()}>
            Promised Date: {selectedOrder.promisedDate}
          </Typography>

          <Typography sx={this.dialogInfoSx()}>
            Location: {selectedOrder.location?.name || '-'}
          </Typography>

          <Typography sx={this.dialogInfoSx()}>
            Supplier: {selectedOrder.supplier?.name || '-'}
          </Typography>

          {selectedOrder.PurchaseOrderProductEntry_po?.length > 0 && (
            <Box mt={2}>
              <TableContainer
                sx={{
                  maxHeight: {
                    xs: "65vh",
                    sm: "70vh"
                  },
                  overflow: "auto"
                }}
              >
                <Table stickyHeader size="small" aria-label="purchase order detail table">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={this.headerCellSx("left")}>
                        <b>Product</b>
                      </TableCell>

                      <TableCell sx={this.headerCellSx("center", 48)}>
                        <b>Unit</b>
                      </TableCell>

                      <TableCell sx={this.headerCellSx("right", 90)}>
                        <b>Quantity</b>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {selectedOrder.PurchaseOrderProductEntry_po.map((line, idx) => {
                      const productId = line.product?.iref || line.product;
                      const product = this.state.productEntries.find(
                        p => String(p.productId) === String(productId)
                      );

                      return (
                        <TableRow key={idx}>
                          <TableCell sx={this.bodyCellSx("left", false)}>
                            {product?.productName || productId || '-'}
                          </TableCell>

                          <TableCell sx={this.bodyCellSx("center", false, 48)}>
                            {unitTypeMap[product?.unit] || '-'}
                          </TableCell>

                          <TableCell sx={this.bodyCellSx("right", false, 90)}>
                            {line.quantity?.toLocaleString()}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    );
  };

  render() {
    const { tabIndex, tabs } = this.state;

    return (
      <Card
        sx={{
          borderRadius: "14px",
          overflow: "hidden",
          maxWidth: "100%",
          height: {
            xs: "calc(100vh - 92px)",
            md: "calc(100vh - 104px)"
          },
          minHeight: {
            xs: 500,
            sm: 540
          },
          display: "flex",
          flexDirection: "column"
        }}
      >
        <Box
          sx={{
            background: "#f6f4ef",
            borderBottom: "1px solid rgba(0,0,0,0.08)"
          }}
        >
          <Tabs
            value={tabIndex}
            onChange={this.handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              minHeight: {
                xs: 40,
                sm: 42
              },
              px: {
                xs: 0.25,
                sm: 0.5
              },
              "& .MuiTab-root": {
                minHeight: {
                  xs: 42,
                  sm: 44
                },
                minWidth: "auto",
                textTransform: "none",
                fontSize: {
                  xs: "13px",
                  sm: "14px"
                },
                fontWeight: 700,
                px: {
                  xs: 1.3,
                  sm: 1.8
                }
              }
            }}
          >
            {tabs.map((label, idx) => (
              <Tab key={idx} label={label} />
            ))}
          </Tabs>
        </Box>

        <Box
          sx={{
            flex: 1,
            minHeight: 0
          }}
        >
          {tabIndex === 0 ? this.renderOrderList() : this.renderNewOrderForm()}
        </Box>

        {this.renderOrderDetailDialog()}
      </Card>
    );
  }

  filterSx() {
    return {
      width: "100%",
      minWidth: 0,
      "& .MuiInputBase-input": {
        fontSize: {
          xs: "16px",
          sm: "14px"
        }
      },
      "& .MuiInputLabel-root": {
        fontSize: {
          xs: "13px",
          sm: "13px"
        }
      }
    };
  }

  dialogInfoSx() {
    return {
      fontSize: {
        xs: "13.5px",
        sm: "14px"
      },
      mb: 0.25
    };
  }

  headerCellSx(align, minWidth = null, compact = false) {
    return {
      padding: compact
        ? {
            xs: "8px 3px",
            sm: "7px 5px"
          }
        : {
            xs: "8px 7px",
            sm: "7px"
          },
      textAlign: align,
      whiteSpace: "nowrap",
      minWidth: minWidth,
      fontSize: {
        xs: "13px",
        sm: "13px",
        md: "14px"
      },
      backgroundColor: "#f6f4ef"
    };
  }

  bodyCellSx(align, strong = false, minWidth = null, compact = false) {
    return {
      padding: compact
        ? {
            xs: "8px 3px",
            sm: "7px 5px"
          }
        : {
            xs: "8px 7px",
            sm: "7px"
          },
      textAlign: align,
      whiteSpace: align === "left" ? "normal" : "nowrap",
      minWidth: minWidth,
      fontSize: {
        xs: "13.5px",
        sm: "13px",
        md: "14px"
      },
      fontWeight: strong ? 600 : 400,
      lineHeight: 1.35
    };
  }
}

export default PurchaseOrderUI;
